import React, { useState } from 'react'
import { Form, InputOnChangeData, Dropdown, Message, Checkbox, Button, Icon, Modal, Header, Popup } from 'semantic-ui-react'
import Flatpickr from 'react-flatpickr';

const NotificationsForm = ({ isSaving, onSubmit }) => {
    
    const [endDate, setEndDate] = useState('')
    const [subject, setSubject] = useState('')
    const [message, setMessage] = useState('')
    const [disableSubmit, setDisableSubmit] = useState(true)
    const [warnMsg, setWarnMsg] = useState('')
    const [errMsg, setErrMsg] = useState('')

    const handleSubmit = () => {
        const endDateISO = getEndDateISO(endDate);
        
        // No rooms will be selected here
        onSubmit(subject, message, endDateISO)

        setSubject('')
        setMessage('')
        setEndDate('')
        setDisableSubmit(true)
        setWarnMsg('')
    }
    
    const getEndDateISO = (date) => {
        date.setDate(date.getDate() + 1);
        return date.toISOString();
    }

    const handleSubjectChange = (e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        if (data.value.length >= 25) {
            setWarnMsg('Only the first 60 characters shall be shown on pinned and rotating alerts')
            
        } else {
            setWarnMsg('')
        }
        setSubject(data.value)
        setDisableSubmit(!data.value || !!errMsg)
    }

    const handleMessageChange = (e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        if (data.value.length >= 60) {
            setWarnMsg("Only the first 60 characters shall be shown on pinned and rotating alerts")
        } else {
            setWarnMsg('')
        }
        setMessage(data.value)
        setDisableSubmit(!data.value || !!errMsg)
    }

    return (
        <Form loading={isSaving} onSubmit={handleSubmit}>
            <Form.Group widths={'equal'}>
                <Form.Input
                    placeholder="Subject"
                    value={subject}
                    onChange={handleSubjectChange}
                />
                <Form.Input
                    placeholder="New Notification"
                    value={message}
                    onChange={handleMessageChange}
                />
                <Form.Button 
                    type="submit" 
                    primary 
                    disabled={
                        disableSubmit || !(subject && message && endDate)
                    }
                >
                    Send Notification
                </Form.Button>
            </Form.Group>
            <Form.Group>
                <Form.Field width={8}>
                    <Flatpickr
                        style={{width: '49%'}}
                        placeholder='End Date'
                        options={{
                            minDate: 'today',
                            dateFormat: 'm/d/Y h:i K',
                            enableTime: true,
                            minTime: new Date(endDate).toDateString() === new Date().toDateString() ? (new Date).setTime((new Date).getTime() + 1000*60*5) : false,
                            defaultHour: new Date().getHours(),
                            defaultMinute: new Date().getMinutes() + 5,
                        }}
                        value={endDate}
                        onChange={data => setEndDate(data[0])}
                    />
                </Form.Field>
            </Form.Group>
            {errMsg && 
                <Message negative>{errMsg}</Message>
            }
            {warnMsg && 
                <Message color='grey'>{warnMsg}</Message>
            }
        </Form>
    )
}

export default NotificationsForm
